import { useEffect, useState } from 'react';
import DashboardLayout from 'components/app/DashboardLayout'
import Button from "components/form/Button"
import axios from 'utils/axios'
import 'react-loading-skeleton/dist/skeleton.css'
import { useAuth } from 'hooks/auth'
import Loader from "components/ui/Loader"
import classNames from 'classnames'
import {
  FirstName,
  LastName,
  Phone,
  Country,
  Email,
  OldPassword,
  NewPassword,
  ConfirmNewPassword
} from 'components/form/FormProfil'
import ErrorMessage from "components/form/ErrorMessage"
import SuccessMessage from "components/form/SuccessMessage"
import ShowPassword from "components/form/ShowPassword"
import {
  country
} from "constants/data-filter";
import { API_ENDPOINTS } from 'utils/api-endpoints';

const tabmenu = [
  {
    title : 'Overview',
    key:1
  },
  {
    title : 'Edit profil',
    key:2
  },
  {
    title : 'Change Password',
    key:3
  }
];

const field = [
  {
    title : 'Firstname',
  },
  {
    title : 'Lastname',
  },
  {
    title : 'Phone',
  },
  {
    title : 'Email',
  },
  {
    title : 'Country',
  },
];

const DisplayProfil = ({
  firstName,
  lastName,
  email,
  phone,
  country
}) => {
return (
  <div className="w-full bg-white px-6 space-y-4 p-4 h-auto">
    <h2 className="block text-md font-bold text-primary py-4">
      Profil details
    </h2>
    <div className="flex flex-row">
      <div className="w-1/2 flex flex-col space-y-6">
        {field.map((item, index)=> (
          <span key={index} className="block text-md font-semibold text-gray-500">
            {item.title}
          </span>
        ))}
      </div>
      <div className="w-1/2 flex overflow-x-auto flex-col space-y-5">
        <Block>
          {firstName}
        </Block>
        <Block>
          {lastName}
        </Block>
        <Block>
          {phone}
        </Block>
        <Block>
          {email}
        </Block>
        <Block>
          {country}
        </Block>
      </div>
    </div>
  </div>
)
}

const Block = ({customClass, children}) => {
  return (
    <span className={`${customClass}${" flex h-6 flex-nowrap block text-md text-primary"}`}>
      {children}
    </span>
  )
}

function Profil() {  
  
  const {user} = useAuth();

  const [isActive, setIsActive] = useState(1),
        [dataProfil, setDataProfil] = useState(
        {
          user_id:null,
          email : '',
          lastName : '',
          firstName : '',
          phone : null,
          country : '',
        });
  
  // handling state
  const [isLoading, setIsLoading] = useState(false),
        [errors, setErrorsMessage] = useState([]),
        [errorText, setErrorText] = useState(null),
        [isReady, setIsReady] = useState(false),
        [isSubmitted, setIsSubmitted] = useState(false),
        [showPwd, setShowPwd] = useState(false),
        [success, setSuccessMessage] = useState(null);

  // Password state    
  const [ pwd, setPwd] = useState(
        {
          current_password : '',
          new_password : '',
          new_password_confirmation :'',
        });

  const getUserProfil = async () => {
    await axios.get(API_ENDPOINTS.USER).then(res => {
      const {data} = res.data;
      setDataProfil({
        user_id   : data?.id,
        email     : data?.email,
        lastName  : data?.lastName,
        firstName : data?.firstName,
        phone     : data?.phone,
        country   : data?.country,
      });
    }).catch((err) => {
      console.log("err", err);
    })
  }

  useEffect(() => {

    if(user?.provider_id!==null&&user?.change_pwd===false){
      setPwd({...pwd, current_password:'notneeoldpassword'})
    }

  }, [user])

  useEffect( () => {
    getUserProfil();
  }, []);

  // Password
  useEffect(() => {

    if(isActive===3){

      if(!pwd.current_password){
        setErrorText("You must enter the old password ");
        setIsReady(false);
      }else if(pwd.new_password !== pwd.new_password_confirmation){ 
        setErrorText("New passwords are not identical");
        setIsReady(false)
      }else{
        setErrorText("");
        setIsReady(true);
      }
    }

  }, [pwd.current_password, pwd.new_password, pwd.new_password_confirmation]);

  // Submit updated profil
  const submitForm = () => {

    setErrorText(null)

    setSuccessMessage(null);

    setErrorsMessage([]);

    setIsLoading(true);

    let dataToUpdate = dataProfil;
    
    delete dataToUpdate.email;

   axios.post(API_ENDPOINTS.UPDATE_PROFIL, dataToUpdate).then(res => {
      if(res.status === 200){ 
        setIsLoading(false);
        setSuccessMessage("Updated successfuly !")
        getUserProfil();
      }
    }).catch((err) => {
      console.log("err", err.response);
      setIsLoading(false);
      setErrorsMessage(" Something went wrong !!! ")
    })
  }

  const submitFormPwd = () => {

    setIsSubmitted(true);
    setErrorsMessage([]);
    setIsLoading(true);

    axios.post(API_ENDPOINTS.UPDATE_PASSWORD, pwd).then(res => {
      if(res.status === 200){ 
        setIsLoading(false);
        setIsSubmitted(false);
        setSuccessMessage("Updated successfuly !")
        setTimeout(() => {
          setIsActive(1);
        }, 1500);
      }
    }).catch((err) => {
      console.log("err", err.response);
      setIsSubmitted(false);
      setIsLoading(false);
      setErrorsMessage(" Something went wrong !!! ")
    })
  }

  return (
    <DashboardLayout>
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
            Profil
          </h2>
        </div>
      </div>
      <div className="w-full flex flex-col">
        <div className="block w-full shadow-xl mb-12">
          <div>
            <ul className="flex flex-row justify-between bg-pblue text-white overflow-x-auto w-full">
                {tabmenu.map(({title, key}) => (
                  <li className="mr-2" key={key}>
                    <button 
                      onClick={()=>setIsActive(key)}
                      className={classNames(
                        isActive === key  ? 'active border-pblue border-b-2 font-bold' : 'fond-semibold',
                        'whitespace-nowrap inline-block text-white rounded-t-lg py-3.5 px-4 text-md text-center cursor-pointer'
                      )}
                    >
                      {title} 
                    </button>
                  </li>
                ))}
            </ul>
          </div>
          <div 
            className={classNames(
              isActive === 1  ? 'block' : 'hidden',
              'h-auto w-full space-y-4 p-2 bg-white'
            )}
          >
            <DisplayProfil 
              firstName={dataProfil.firstName}
              lastName={dataProfil.lastName}
              email={dataProfil.email}
              phone={dataProfil.phone}
              country={dataProfil.country}
            />
          </div>
          <div 
            className={classNames(
              isActive === 2  ? 'block' : 'hidden',
              'h-auto w-full space-y-4 p-8 bg-white'
            )}
          >
            <FirstName 
              value={dataProfil.firstName} 
              onChange={(e)=>setDataProfil({...dataProfil, firstName: e.target.value})} 
            />
            <LastName 
              value={dataProfil.lastName} 
              onChange={(e)=>setDataProfil({...dataProfil, lastName: e.target.value})} 
            />
            <Phone 
              value={dataProfil.phone} 
              onChange={(e)=>setDataProfil({...dataProfil, phone: e.target.value})} 
            />
            <Country 
              value={dataProfil.country} 
              defaultValue={dataProfil?.country}
              options={country} 
              onChange={(e)=>setDataProfil({...dataProfil, country: e?.countries})}
            />
            <Email value={dataProfil.email}/>
            
            <ErrorMessage errors={errors} />
            <SuccessMessage success={success} handleHideMsg={()=>setSuccessMessage('')} />

            {/* Action */}
            <div className="flex flex-col py-4 items-end">

              <Button 
                disabled={isLoading} 
                onClick={()=>submitForm()}
                className={classNames(
                  !isLoading ? '' : 'bg-gray-500 opacity-50 cursor-not-allowed',
                  ""
                )}
              >
                {!isLoading ?  'Update' : 
                  <> <Loader /> <span className="mr-1"></span> Updating... </>
                }
              </Button>
            </div>
          </div>
          <div 
            className={classNames(
              isActive === 3  ? 'block' : 'hidden',
              'h-auto w-full space-y-4 p-8 bg-white'
            )}
          >
            { (user?.provider_id!==null&&user?.change_pwd===false) ?
              <p className="text-center">
                You have authenticated with google. Set a password for future connections or continue to use google
              </p>
              :
              <OldPassword 
                value={pwd.current_password} 
                showPwd={showPwd}
                onChange={(e)=>setPwd({...pwd, current_password: e.target.value})}  
                isSubmitted={isSubmitted}
                isRequired={true} 
              />
            }
            <NewPassword 
              value={pwd.new_password} 
              showPwd={showPwd}
              onChange={(e)=>setPwd({...pwd, new_password: e.target.value})} 
              isSubmitted={isSubmitted}
              isRequired={true} 
             />
            <ConfirmNewPassword 
              value={pwd.new_password_confirmation} 
              showPwd={showPwd}
              onChange={(e)=>setPwd({...pwd, new_password_confirmation: e.target.value})}  
              isSubmitted={isSubmitted}
              isRequired={true} 
            />
            {/* Hide or Show password */}
            <ShowPassword onClick={()=>setShowPwd(!showPwd) }/>

            {/* Erros handle */}
            <ErrorMessage errors={errors} />
            
            {errorText&&<p className="text-md text-red-500">{errorText} </p>}

            <SuccessMessage success={success} handleHideMsg={()=>setSuccessMessage('')} />

            <div className="flex flex-col py-4 items-end">
              <Button
                disabled={isLoading||!isReady} 
                onClick={()=>submitFormPwd()}
                className={classNames(
                  isReady ? '' : 'bg-gray-400 opacity-50 cursor-not-allowed',
                  !isLoading ? '' : 'bg-gray-500 opacity-50 cursor-not-allowed',
                  ""
                )}
              >
                {!isLoading ?  'Update' : 
                  <> <Loader /> <span className="mr-1"></span> Updating... </>
                }
              </Button>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}

export default Profil;